import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./lib/AuthContext";
import { PeriodProvider } from "./lib/PeriodContext";

import { Splash } from "./components/Splash";
import { Layout } from "./components/Layout";

import LoginPage from "./pages/Login";
import ExecutiveCommandCenter from "./pages/ExecutiveCommandCenter";
import SalesIntelligence from "./pages/SalesIntelligence";
import CollectionIntelligence from "./pages/CollectionIntelligence";
import TargetVsAchievement from "./pages/TargetVsAchievement";
import ProjectIntelligence from "./pages/ProjectIntelligence";
import InventoryIntelligence from "./pages/InventoryIntelligence";
import BlockedUnits from "./pages/BlockedUnits";
import EngineeringMilestone from "./pages/EngineeringMilestone";
import StrategicInsights from "./pages/StrategicInsights";
import MarketIntelligence from "./pages/MarketIntelligence";
import VexenAI from "./pages/VexenAI";
import Settings from "./pages/Settings";

const RequireAuth = ({ children }) => {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
};

const ProtectedShell = () => (
  <PeriodProvider>
    <Layout />
  </PeriodProvider>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <ProtectedShell />
          </RequireAuth>
        }
      >
        <Route index element={<ExecutiveCommandCenter />} />
        <Route path="/sales" element={<SalesIntelligence />} />
        <Route path="/collection" element={<CollectionIntelligence />} />
        <Route path="/targets" element={<TargetVsAchievement />} />
        <Route path="/projects" element={<ProjectIntelligence />} />
        <Route path="/inventory" element={<InventoryIntelligence />} />
        <Route path="/blocked" element={<BlockedUnits />} />
        <Route path="/engineering" element={<EngineeringMilestone />} />
        <Route path="/strategic" element={<StrategicInsights />} />
        <Route path="/market" element={<MarketIntelligence />} />
        <Route path="/vexen-ai" element={<VexenAI />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  const [splash, setSplash] = useState(() => !sessionStorage.getItem("vexen_splash_done"));

  useEffect(() => {
    if (splash) {
      const t = setTimeout(() => {
        sessionStorage.setItem("vexen_splash_done", "1");
        setSplash(false);
      }, 1600);
      return () => clearTimeout(t);
    }
  }, [splash]);

  return (
    <AuthProvider>
      <BrowserRouter>
        {splash && <Splash onDone={() => setSplash(false)} />}
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
